function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { CoreVideoInternal } from '../../../core-video-internal';
import { sdkLogger } from '../../../logger';
import { PerfKey, perfLogger, PerfTag } from '../../../utils/perf';
import { checkIsManifestVodType } from '../../../utils/playback-type';
import { getStreamVendor } from '../../../utils/stream-vendor';
import { VideoColourSpace } from '../../player/video-format';
import { SessionRestartType } from '../restart/session-restart-controller';
import { TelemetryNotificationKey } from '../../telemetry/telemetry-session';
import { isRawSessionItem } from '../session-controller';
import { SmootherType } from '@sky-uk-ott/vpt-abr-network-estimator';
export var VideoProviderController = /*#__PURE__*/ function() {
    "use strict";
    function VideoProviderController() {
        _class_call_check(this, VideoProviderController);
        var _this = this;
        _define_property(this, "telemetryData", []);
        _define_property(this, "getVpiPlayoutData", /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function(sessionItem, videoPlatformIntegration, retrySessionOverrides, isPrefetch) {
                var playoutData, _tmp, originalPlayoutData;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            perfLogger.measure(PerfKey.root, PerfTag.ovpRequest);
                            _tmp = [
                                {}
                            ];
                            return [
                                4,
                                videoPlatformIntegration.getPlayoutData(sessionItem, _this.getVpiSessionRequestOptions(retrySessionOverrides, isPrefetch), _this.getVpiSessionResponseOptions(retrySessionOverrides))
                            ];
                        case 1:
                            playoutData = _object_spread_props.apply(void 0, [
                                _object_spread.apply(void 0, _tmp.concat([
                                    _state.sent()
                                ])),
                                {
                                    initialBitrateBps: _this.getInitialBitrate(sessionItem)
                                }
                            ]);
                            originalPlayoutData = _this.overridePlayoutDataWithRestartOptions(playoutData, sessionItem, retrySessionOverrides);
                            perfLogger.measure(PerfKey.root, PerfTag.ovpResponse);
                            return [
                                2,
                                originalPlayoutData
                            ];
                    }
                });
            });
            return function(sessionItem, videoPlatformIntegration, retrySessionOverrides, isPrefetch) {
                return _ref.apply(this, arguments);
            };
        }());
        _define_property(this, "getVpiSessionRequestOptions", function(retrySessionOverrides, isPrefetch) {
            return _object_spread({
                isPrefetch: isPrefetch,
                isRetrying: (retrySessionOverrides === null || retrySessionOverrides === void 0 ? void 0 : retrySessionOverrides.restartType) === SessionRestartType.VPF_RETRY
            }, retrySessionOverrides === null || retrySessionOverrides === void 0 ? void 0 : retrySessionOverrides.playoutRequestOverrides);
        });
        _define_property(this, "getVpiSessionResponseOptions", function(retrySessionOverrides) {
            return {
                penalizedCdnName: retrySessionOverrides === null || retrySessionOverrides === void 0 ? void 0 : retrySessionOverrides.penalizedCdnName,
                isRetrying: (retrySessionOverrides === null || retrySessionOverrides === void 0 ? void 0 : retrySessionOverrides.restartType) === SessionRestartType.VPF_RETRY
            };
        });
    }
    _create_class(VideoProviderController, [
        {
            key: "fetchPlayoutData",
            value: function fetchPlayoutData(sessionItem, videoPlatformIntegration, retrySessionOverrides, isPrefetch) {
                var _this = this;
                return _async_to_generator(function() {
                    var vpiPlayoutDataPromise;
                    return _ts_generator(this, function(_state) {
                        perfLogger.measure(PerfKey.root, PerfTag.playoutRequest);
                        // reset telemetryData before calculating the new ovpDownloadTime
                        _this.telemetryData = [];
                        _this.telemetryData.push({
                            key: TelemetryNotificationKey.ovpRequestStart,
                            value: new Date().getTime()
                        });
                        if (isRawSessionItem(sessionItem)) {
                            vpiPlayoutDataPromise = Promise.resolve(_this.getStaticPlayoutData(sessionItem));
                        } else {
                            vpiPlayoutDataPromise = _this.getVpiPlayoutData(sessionItem, videoPlatformIntegration, retrySessionOverrides, isPrefetch);
                        }
                        _this.telemetryData.push({
                            key: TelemetryNotificationKey.ovpResponseEnd,
                            value: new Date().getTime()
                        });
                        return [
                            2,
                            vpiPlayoutDataPromise.then(function(r) {
                                perfLogger.measure(PerfKey.root, PerfTag.playoutResponse);
                                return r;
                            })
                        ];
                    });
                })();
            }
        },
        {
            key: "getTelemetryData",
            value: function getTelemetryData() {
                return this.telemetryData;
            }
        },
        {
            key: "getInitialBitrate",
            value: function getInitialBitrate(sessionItem) {
                var initialBitrate = sessionItem.initialBitrateBps;
                if (initialBitrate === undefined && CoreVideoInternal.bandwidthEstimator) {
                    if ('getBandwidthEstimate' in CoreVideoInternal.bandwidthEstimator) {
                        initialBitrate = CoreVideoInternal.bandwidthEstimator.getBandwidthEstimate({
                            forceUpdate: true
                        });
                    } else {
                        CoreVideoInternal.bandwidthEstimator.forceUpdate();
                        var smoother = CoreVideoInternal.bandwidthEstimator.getSmoother({
                            type: SmootherType.HARMONIC_MEAN
                        });
                        initialBitrate = smoother.getValue();
                        smoother.unregister();
                    }
                }
                sdkLogger.info("Using initial bitrate: ".concat(initialBitrate !== null && initialBitrate !== void 0 ? initialBitrate : 'default'));
                return initialBitrate;
            }
        },
        {
            key: "getStaticPlayoutData",
            value: function getStaticPlayoutData(sessionItem) {
                var _sessionItem_manifests = sessionItem.manifests, manifests = _sessionItem_manifests === void 0 ? [] : _sessionItem_manifests, position = sessionItem.startPosition, protocol = sessionItem.protocol, reporting = sessionItem.reporting, autoplay = sessionItem.autoplay, preferredAudioMetadata = sessionItem.preferredAudioMetadata, preferredSubtitleMetadata = sessionItem.preferredSubtitleMetadata, preferredAudioLanguages = sessionItem.preferredAudioLanguages, preferredSubtitlesLanguages = sessionItem.preferredSubtitlesLanguages, source = sessionItem.source, playerBitrateLimits = sessionItem.playerBitrateLimits, type = sessionItem.type, drmConfiguration = sessionItem.drmConfiguration, advertising = sessionItem.advertising, _sessionItem_colourSpace = sessionItem.colourSpace, colourSpace = _sessionItem_colourSpace === void 0 ? VideoColourSpace.SDR : _sessionItem_colourSpace, sessionId = sessionItem.sessionId;
                var cdns = manifests.map(function(manifest, index) {
                    return {
                        url: manifest,
                        name: "CDN ".concat(index),
                        vendor: getStreamVendor(manifest)
                    };
                });
                var stream = {
                    protocol: protocol,
                    colourSpace: colourSpace
                };
                var playoutData = {
                    type: type,
                    cdns: cdns,
                    stream: stream,
                    source: source,
                    autoplay: autoplay,
                    position: position,
                    drmConfiguration: drmConfiguration,
                    preferredAudioMetadata: preferredAudioMetadata,
                    preferredSubtitleMetadata: preferredSubtitleMetadata,
                    preferredAudioLanguages: preferredAudioLanguages,
                    preferredSubtitlesLanguages: preferredSubtitlesLanguages,
                    custom: {
                        nativeReporting: reporting && _object_spread({}, reporting)
                    },
                    playerBitrateLimits: playerBitrateLimits,
                    advertising: advertising,
                    sessionId: sessionId,
                    initialBitrateBps: this.getInitialBitrate(sessionItem)
                };
                return playoutData;
            }
        },
        {
            key: "overridePlayoutDataWithRestartOptions",
            value: function overridePlayoutDataWithRestartOptions(playoutData, sessionItem, retrySessionOverrides) {
                if (retrySessionOverrides === null) {
                    return playoutData;
                }
                var isVodManifest = checkIsManifestVodType(sessionItem.type);
                var _retrySessionOverrides_playoutDataOverrides = retrySessionOverrides.playoutDataOverrides, muted = _retrySessionOverrides_playoutDataOverrides.muted, volume = _retrySessionOverrides_playoutDataOverrides.volume, preferredAudioTrack = _retrySessionOverrides_playoutDataOverrides.preferredAudioTrack, preferredSubtitlesTrack = _retrySessionOverrides_playoutDataOverrides.preferredSubtitlesTrack, linearPosition = _retrySessionOverrides_playoutDataOverrides.linearPosition, position = _retrySessionOverrides_playoutDataOverrides.position;
                var playoutDataOverrides = _object_spread({}, !playoutData.autoplay && {
                    autoplay: true
                }, Boolean(muted !== undefined) && {
                    muted: muted
                }, Boolean(volume !== undefined) && {
                    volume: volume
                }, Boolean(preferredAudioTrack !== undefined) && {
                    preferredAudioTrack: preferredAudioTrack
                }, Boolean(preferredSubtitlesTrack !== undefined) && {
                    preferredSubtitlesTrack: preferredSubtitlesTrack
                }, Boolean(isVodManifest && position) && {
                    position: position
                }, Boolean(!isVodManifest && linearPosition) && {
                    linearPosition: linearPosition
                });
                return _object_spread({}, playoutData, playoutDataOverrides);
            }
        }
    ]);
    return VideoProviderController;
}();

//# sourceMappingURL=video-provider-controller.js.map